var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStockGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1561_70986)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8099 2.5C2.27013 2.5 2.64323 2.8731 2.64323 3.33333V15C2.64323 15.4602 3.01633 15.8333 3.47656 15.8333H18.4766C18.9368 15.8333 19.3099 16.2064 19.3099 16.6667C19.3099 17.1269 18.9368 17.5 18.4766 17.5H3.47656C2.09585 17.5 0.976562 16.3807 0.976562 15V3.33333C0.976562 2.8731 1.34966 2.5 1.8099 2.5Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1419 4.16699C14.6817 4.16699 14.3086 4.54009 14.3086 5.00033V13.3337C14.3086 13.7939 14.6817 14.167 15.1419 14.167C15.6022 14.167 15.9753 13.7939 15.9753 13.3337V5.00033C15.9753 4.54009 15.6022 4.16699 15.1419 4.16699Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47526 5.83366C8.01502 5.83366 7.64193 6.20675 7.64193 6.66699V13.3337C7.64193 13.7939 8.01502 14.167 8.47526 14.167C8.9355 14.167 9.30859 13.7939 9.30859 13.3337V6.66699C9.30859 6.20675 8.9355 5.83366 8.47526 5.83366Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14193 10.8337C4.68169 10.8337 4.30859 11.2068 4.30859 11.667V13.3337C4.30859 13.7939 4.68169 14.167 5.14193 14.167C5.60216 14.167 5.97526 13.7939 5.97526 13.3337V11.667C5.97526 11.2068 5.60216 10.8337 5.14193 10.8337Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9753 8.33366C10.9753 7.87342 11.3484 7.50033 11.8086 7.50033C12.2688 7.50033 12.6419 7.87342 12.6419 8.33366V13.3337C12.6419 13.7939 12.2688 14.167 11.8086 14.167C11.3484 14.167 10.9753 13.7939 10.9753 13.3337V8.33366Z",
    fill: "#777E91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1561_70986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.142578)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockGraph);
export default __webpack_public_path__ + "static/media/stockGraph.515ab317e28437129913b7c63d0f5cbb.svg";
export { ForwardRef as ReactComponent };